import { AUTOPAY_STATUS_META } from "@/lib/billing";

/**
 * Compact chip used wherever we surface autopay enrolment state:
 * parent /billing card, admin /billing row, admin family header.
 *
 * Emits both data-status (for tests) and data-autopay=true|false to make
 * it trivially queryable in automation + documents.
 */
export default function AutopayStatusChip({ status, testId }) {
  const meta = AUTOPAY_STATUS_META[status] || AUTOPAY_STATUS_META.none;
  return (
    <span
      data-testid={testId || `autopay-chip-${status || "none"}`}
      data-status={status || "none"}
      data-autopay={status === "active" ? "true" : "false"}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${meta.tone}`}
    >
      {meta.label}
    </span>
  );
}
